export var InvoiceDisplayStatus = /*#__PURE__*/ function(InvoiceDisplayStatus) {
    InvoiceDisplayStatus["Issued"] = "issued";
    InvoiceDisplayStatus["Pending"] = "pending";
    InvoiceDisplayStatus["Overdue"] = "overdue";
    InvoiceDisplayStatus["Processing"] = "processing";
    InvoiceDisplayStatus["Paid"] = "paid";
    InvoiceDisplayStatus["RefundFailed"] = "refundFailed";
    InvoiceDisplayStatus["Refunded"] = "refunded";
    InvoiceDisplayStatus["PartiallyRefunded"] = "partiallyRefunded";
    InvoiceDisplayStatus["Voided"] = "voided";
    InvoiceDisplayStatus["Disputed"] = "disputed";
    return InvoiceDisplayStatus;
}({});
export var InvoiceStatusType = /*#__PURE__*/ function(InvoiceStatusType) {
    InvoiceStatusType["Pending"] = "pending";
    InvoiceStatusType["ProcessingCharge"] = "processingCharge";
    InvoiceStatusType["PaymentActionRequired"] = "paymentActionRequired";
    InvoiceStatusType["RequiresPaymentApproval"] = "requiresPaymentApproval";
    InvoiceStatusType["PaymentConfirmed"] = "paymentConfirmed";
    InvoiceStatusType["PaymentFailed"] = "paymentFailed";
    InvoiceStatusType["Paid"] = "paid";
    InvoiceStatusType["PaidExternally"] = "paidExternally";
    InvoiceStatusType["Voided"] = "voided";
    InvoiceStatusType["Refunded"] = "refunded";
    InvoiceStatusType["RefundFailed"] = "refundFailed";
    InvoiceStatusType["PaymentStopped"] = "paymentStopped";
    InvoiceStatusType["PaymentDisputed"] = "paymentDisputed";
    InvoiceStatusType["PartiallyRefunded"] = "partiallyRefunded";
    return InvoiceStatusType;
}({});
export var ApprovalMethodType = /*#__PURE__*/ function(ApprovalMethodType) {
    ApprovalMethodType["Manual"] = "manual";
    ApprovalMethodType["Automatic"] = "auto";
    return ApprovalMethodType;
}({});
export var PaymentMethod = /*#__PURE__*/ function(PaymentMethod) {
    PaymentMethod["Ach"] = "ach";
    PaymentMethod["CreditCard"] = "creditCard";
    return PaymentMethod;
}({});
export var PaymentProcessor = /*#__PURE__*/ function(PaymentProcessor) {
    PaymentProcessor["Stripe"] = "stripe";
    PaymentProcessor["Column"] = "column";
    return PaymentProcessor;
}({});
export var RefundStatus = /*#__PURE__*/ function(RefundStatus) {
    RefundStatus["Pending"] = "pending";
    RefundStatus["Succeeded"] = "succeeded";
    RefundStatus["Failed"] = "failed";
    RefundStatus["Canceled"] = "canceled";
    return RefundStatus;
}({});
export var PricingType = /*#__PURE__*/ function(PricingType) {
    PricingType["Fixed"] = "fixed";
    PricingType["Variable"] = "variable";
    return PricingType;
}({});
export var ProcessingActionType = /*#__PURE__*/ function(ProcessingActionType) {
    ProcessingActionType["Sdk"] = "sdk";
    ProcessingActionType["Redirect"] = "redirect";
    return ProcessingActionType;
}({});
export var LineItemOriginType = /*#__PURE__*/ function(LineItemOriginType) {
    LineItemOriginType["Service"] = "service";
    LineItemOriginType["AdHocCharge"] = "adHocCharge";
    LineItemOriginType["ServiceBundle"] = "serviceBundle";
    return LineItemOriginType;
}({});
import { PaymentDetailType } from '../api/invoice';
export { PaymentDetailType };
export var InvoiceIntegrationStatusValue = /*#__PURE__*/ function(InvoiceIntegrationStatusValue) {
    InvoiceIntegrationStatusValue["PendingSync"] = "pendingSync";
    InvoiceIntegrationStatusValue["InvoiceSynced"] = "invoiceSynced";
    InvoiceIntegrationStatusValue["InvoiceSyncFailed"] = "invoiceSyncFailed";
    InvoiceIntegrationStatusValue["VoidSynced"] = "voidSynced";
    InvoiceIntegrationStatusValue["PaymentSynced"] = "paymentSynced";
    InvoiceIntegrationStatusValue["PaymentSyncFailed"] = "paymentSyncFailed";
    InvoiceIntegrationStatusValue["RefundSynced"] = "refundSynced";
    InvoiceIntegrationStatusValue["RefundSyncFailed"] = "refundSyncFailed";
    return InvoiceIntegrationStatusValue;
}({});
